import { RESET_STATE, SEARCH_PRODUCTS_BEGIN, SEARCH_PRODUCTS_FAILURE, SET_SEARCH_PRODUCTS_RESULT, SET_SEARCH_PRODUCTS_VALUE } from './search.types';

export const searchProductsBegin = () => ({ type: SEARCH_PRODUCTS_BEGIN });
export const searchProductsValue = value => ({ type: SET_SEARCH_PRODUCTS_VALUE, payload: { value } });
export const searchProductsResult = result => ({ type: SET_SEARCH_PRODUCTS_RESULT, payload: { result } });
export const searchProductsFailure = error => ({ type: SEARCH_PRODUCTS_FAILURE, payload: { error } });
export const resetState = () => ({ type: RESET_STATE });

